// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/btn_style_one.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/btn_style_two.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Barlow:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixed_bg {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  inset: 0;
  z-index: -1;
}
.fixed_bg:after {
  content: "";
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.41);
}

.banner {
  background-color: rgb(209 202 201 / 80%);
  padding: 2rem 0;
}
.banner_text h2 {
  font-size: 3.4rem;
}
.banner_text .btn {
  background-color: #b03737;
  color: #fff;
  font-size: 14px;
  padding: 0.8rem 2rem;
  line-height: 1;
  transition: all 0.3s ease;
  border: 1px solid #b03737;
}
.banner_text .btn:hover {
  background-color: #fff;
  color: #b03737;
}

.sales {
  padding: 3rem 0;
}
.sales_title > h2 {
  /* font-size: 2.5rem; */
  /* color: #00305b;
  line-height: 1;
  margin-bottom: 2rem; */
}
.sales_text > h2 {
  font-size: 3.438rem;
  color: #00305b;
  line-height: 1;
  font-weight: 300 !important;
}
.sales_text p {
  letter-spacing: 0.19rem;
  /* color: #00305b; */
  font-size: 1.188rem;
  font-weight: 500;
}
.sales_text{
  text-align: center;
}

.btn_style_one {
  position: relative;
  overflow: hidden;
  background-color: #fff !important;
  padding: 0.5rem 4rem;
  /* letter-spacing: 0.15rem; */
  font-size: 14px;
  font-weight: 500;
}
.btn_style_one:after {
  content: "";
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  inset: 0;
  position: absolute;
  opacity: 0.2;
  transition: transform 0.2s ease-in-out;
}
.btn_style_one:hover:after {
  transform: scale(1.2);
}
.btn_style_one > span {
  position: relative;
  z-index: 1;
  transition: transform 0.3s ease-in-out;
  display: inline-block;
  color: #2f2e2e;
}
.btn_style_one:hover > span {
  transform: scale(1.06);
}

.ittyb {
  padding: 2rem 0;
  background-attachment: fixed !important;
}
.ittyb_title > h2 {
  font-size: 3.438rem;
  line-height: 1;
  margin-bottom: 2rem;
  letter-spacing: 0.1rem;
}

.ittyb_item > h2 {
  font-size: 1.3rem;
  font-weight: 400;
  margin-top: 2rem;
  letter-spacing: 0.1rem;
  margin-bottom: 1.5rem;
}
.ittyb_item,
.ittyb_bt {
  margin-bottom: 2rem;
}
.ittyb_item > p {
  text-shadow: rgba(255, 255, 255, 0.6) 1px 1px 1px,
    rgba(0, 0, 0, 0.6) -1px -1px 1px;
  color: #b3f2ff;
}
.ittyb_bt > h3 {
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  margin-bottom: 1.5rem;
}

.video_banner {
  height: 490px;
  overflow: hidden;
  background-color: #2f2e2e;
}

.features {
  padding-bottom: 0.2rem;
}
.section_sales_heading{
  font-size: 50px;
    line-height: 1em;
    text-align: center;
    font-weight: bold;
    color: #00305B;
    letter-spacing: normal;
}
@media (min-width: 768px) {
  .features_item {
    flex: 0 0 auto;
    width: 20%;
  }
  .testimonials_section{
    margin-bottom: 80px;
  }
}
.features_item {
  padding: 4.5rem 2.5rem;
  color: #fff;
  text-align: center;
}
.fi_card > img {
  width: 4.875rem;
  height: 4.875rem;
  object-fit: contain;
  object-position: center center;
}
.features_item ul {
  text-align: left;
}
.fi_cta > a {
  color: #fff;
  text-decoration: none;
}
.fi_cta > a:hover {
  text-decoration: underline;
}
.fi_card > h2 {
  font-size: 1.4rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.25rem;
  line-height: 1;
}

.gift_of_travel_new {
  background-color: #fff;
  padding: 3rem 0;
}
.gt_title {
  margin-bottom: 4rem;
}
.gt_title > h2 {
  font-size: 2.125rem;
  letter-spacing: 0.15rem;
  font-weight: 300;
}
.gt_title > p {
  font-size: 1.2rem;
}
.gallery_item img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  object-position: center;
}
.gellery_ovarley {
  position: absolute;
  background-color: rgba(47, 46, 46, 0.6);
  inset: 0;
  transition: opacity 0.3s ease;
  opacity: 0;
  pointer-events: none;
}
.gallery_item:hover .gellery_ovarley,
.gallery_item:hover .react_btn,
.gallery_item:hover .share_btn {
  opacity: 1;
}
.react_btn,
.share_btn {
  position: absolute;
  bottom: 2rem;
  width: 3rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: #fff;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.react_btn {
  left: 2rem;
}
.share_btn {
  right: 2rem;
}

.vacation_offers {
  padding: 2rem 0;
}
.vo_title {
  margin-bottom: 3rem;
}
.vo_title > h2 {
  font-size: 3.625rem;
  line-height: 1;
  margin: 0;
  font-family: "Barlow", sans-serif;
}
.swiperVo-prev,
.swiperVo-next {
  position: absolute;
  /* top: 0; */
  bottom: 0;
  z-index: 10;
  cursor: pointer;
  color: #fff;
}
.swiperVo-prev:hover,
.swiperVo-next:hover {
  background-color: rgb(255 255 255 / 55%);
  color: #282828;
}
.swiperVo-prev {
  left: 0;
}
.swiperVo-next {
  right: 0;
}
.swiperVo .swiper-slide {
  position: relative;
}
.gi_react {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(110, 105, 104, 0.6);
  transition: opacity 0.3s ease;
  opacity: 0;
}
.swiperVo .swiper-slide:hover .gi_react {
  opacity: 1;
}
.gi_react > span {
  width: 3rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  cursor: pointer;
}

.wwo {
  padding-bottom: 3rem;
}
.wwo_wrapper {
  border: 2px solid #e9e9e9;
  margin: 0 8rem;
}
.wwo_item {
  padding: 2rem 3.5rem;
  position: relative;
}
.wwo_item > img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  object-position: center;
  margin-bottom: 1.2rem;
}
.wwo_item:nth-child(2):after,
.wwo_item:nth-child(2):before {
  content: "";
  position: absolute;
  width: 2px;
  top: 3rem;
  bottom: 3rem;
  background-color: #fff;
}
.wwo_item:nth-child(2):before {
  left: 0;
}

.wwo_item:nth-child(2):after {
  right: 0;
}

.imagine {
  background-color: rgb(209 202 201 / 50%);
  padding: 2rem 0;
}
.imagine_title h2 {
  font-size: 2.5rem;
}
.imagine_title p {
  font-size: 1.4rem;
  font-weight: 500;
}
.imagine_text p {
  font-size: 1rem;
  font-weight: 500;
}

.trial {
  background-color: rgb(53 74 89 / 50%);
  padding: 3rem 0;
}
.trial_title h2 {
  font-size: 3.5rem;
}

.plan {
  background-color: #fff;
  padding: 2rem 0;
}
.plan_title h2 {
  font-size: 3.5rem;
  color: #354a59;
  margin: 0;
}
.plan_title h5 {
  font-size: 1.313rem;
  color: #6e6968;
}
.plan_text_list {
  padding: 2rem 10vw 0;
}
/* .pt_item {
  height: 100%;
  border: 2px solid #345166;
  padding: 2rem;
} */
.pt_item {
  height: 100%;
  border-right: 2px solid #345166;
  padding: 2rem;
}

.pt_item {
  height: 100%;
  border-right: 3px solid #345166;
  padding: 2rem;
}
.pt_item h2 {
  font-size: 2rem;
  color: #354a59;
  line-height: 1;
}
.plan_price {
  /* font-size: 2rem; */
  color: #354a59;
  /* font-weight: 800; */
  line-height: 1.2;
  margin-bottom: 1rem;
}
.pt_item p {
  color: #354a59;
  font-size: 1.1rem;
}
.btn_style_two {
  display: inline-block;
  position: relative;
  overflow: hidden;
  padding: 0.8rem 2rem;
  line-height: 1;
  border: 0;
  box-shadow: none;
  transition: box-shadow 0.2s ease-in-out;
}
.btn_style_two:hover {
  box-shadow: 1.41px 1.41px 4px rgba(0, 0, 0, 0.15);
}
.btn_style_two:after {
  content: "";
  background: #fffdf4 url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  inset: 0;
  position: absolute;
  opacity: 0.2;
  transition: transform 0.2s ease-in-out;
  background-size: 70%;
}

.plan_tires {
  border: 2px solid #345166;
  padding: 20px;
}

.btn_style_two:before {
  content: "";
  position: absolute;
  inset: 0;
  background-color: #a0b3c1;
  z-index: 1;
}

.btn_style_two:hover:before {
  opacity: 0;
}
.btn_style_two > span {
  color: #22282c;
  position: relative;
  z-index: 10;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  transition: transform 0.2s ease-in-out;
}
.btn_style_two:hover > span {
  transform: scale(1.08);
}

.get_it {
  background-color: #fff;
  padding: 3rem 0 2rem;
}
.getit_title h2 {
  font-size: 3.5rem;
  font-weight: 400;
  color: #00305b;
  letter-spacing: 0.19rem;
}
.vf_wrapper {
  padding: 1rem 10vw 0;
}
.getit_form .form-control {
  border-color: #3c3c3c;
}

.swiperTestimonials-prev,
.swiperTestimonials-next {
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  color: #fff;
}
.swiperTestimonials-prev {
  left: 0;
}
.swiperTestimonials-next {
  right: 0;
}

.landing {
  font-family: "Barlow", sans-serif;
  font-weight: 400;
  color: #2f2e2e;
}
.landing h1, 
.landing h2, 
.landing h3, 
.landing h4, 
.landing h5, 
.landing h6 {
  font-family: "Barlow Condensed", sans-serif;
  font-weight: 500;
}

@media (min-width: 1300px) {
  .landing .container, 
  .landing .container-lg, 
  .landing .container-md, 
  .landing .container-sm, 
  .landing .container-xl {
      max-width: 1260px;
  }
  .testimonials_section{
    margin-bottom: 250px;
  }
}

@media screen and (max-width: 1024px) {
  .features_item {
    padding: 3rem 1rem;
  }
  .fi_card > h2 {
    letter-spacing: 0;
    font-size: 1.2rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .ittyb_item img {
    width: 80px;
    height: 80px;
  }
  .testimonials_section{
    margin-bottom: 250px;
  }
}
@media screen and (max-width: 991px) {
  .getit_title h2,
  .vo_title > h2,
  .imagine_title h2,
  .ittyb_title > h2 {
    font-size: 2.5rem;
  }
  .pt_item {
    padding: 1rem;
  }
  .plan_text_list {
    padding: 2rem 0 0;
  }
  .wwo_wrapper {
    margin: 0;
  }
  .testimonials_section{
    margin-bottom: 100px;
  }
}
@media screen and (max-width: 767px) {
  .banner_img {
    text-align: center;
  }
  .banner_text h2 {
    font-size: 2.4rem;
  }
  .video_banner {
    height: 340px;
  }
  .sales_text > h2,
  .sales_title > h2,
  .getit_title h2,
  .vo_title > h2,
  .imagine_title h2,
  .ittyb_title > h2,
  .trial_title h2,
  .plan_title h2 {
    font-size: 2rem;
  }
  .sales_text p {
    letter-spacing: 0;
    font-size: 1rem;
  }
  .wwo_item:nth-child(2):after,
  .wwo_item:nth-child(2):before {
    display: none;
  }
  .plan_tires .row {
    row-gap: 1rem;
  }
  .testimonials_section{
    margin-bottom: 50px;
  }
}
@media screen and (max-width: 475px) {
  .btn_style_one {
    padding: 0.5rem 2rem;
  }
  .testimonials_section{
    margin-bottom: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/reffer/referal.css"],"names":[],"mappings":"AACA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,MAAM;EACN,QAAQ;EACR,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB;;wBAEsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,wDAA2D;EAC3D,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE;oCACkC;EAClC,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;AACA;EACE;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,QAAQ;EACR,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;AACtB;AACA;;;EAGE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,iCAAiC;AACnC;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;AACb;AACA;;EAEE,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;;;;GAIG;AACH;EACE,YAAY;EACZ,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,2DAA8D;EAC9D,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,WAAW;AACb;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;;EAME,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE;;;;;MAKI,iBAAiB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;;;;IAIE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;;;;;;;;IAQE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Barlow:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap');\n.fixed_bg {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  inset: 0;\n  z-index: -1;\n}\n.fixed_bg:after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.41);\n}\n\n.banner {\n  background-color: rgb(209 202 201 / 80%);\n  padding: 2rem 0;\n}\n.banner_text h2 {\n  font-size: 3.4rem;\n}\n.banner_text .btn {\n  background-color: #b03737;\n  color: #fff;\n  font-size: 14px;\n  padding: 0.8rem 2rem;\n  line-height: 1;\n  transition: all 0.3s ease;\n  border: 1px solid #b03737;\n}\n.banner_text .btn:hover {\n  background-color: #fff;\n  color: #b03737;\n}\n\n.sales {\n  padding: 3rem 0;\n}\n.sales_title > h2 {\n  /* font-size: 2.5rem; */\n  /* color: #00305b;\n  line-height: 1;\n  margin-bottom: 2rem; */\n}\n.sales_text > h2 {\n  font-size: 3.438rem;\n  color: #00305b;\n  line-height: 1;\n  font-weight: 300 !important;\n}\n.sales_text p {\n  letter-spacing: 0.19rem;\n  /* color: #00305b; */\n  font-size: 1.188rem;\n  font-weight: 500;\n}\n.sales_text{\n  text-align: center;\n}\n\n.btn_style_one {\n  position: relative;\n  overflow: hidden;\n  background-color: #fff !important;\n  padding: 0.5rem 4rem;\n  /* letter-spacing: 0.15rem; */\n  font-size: 14px;\n  font-weight: 500;\n}\n.btn_style_one:after {\n  content: \"\";\n  background: #fff url(../../assets/images/btn_style_one.png);\n  inset: 0;\n  position: absolute;\n  opacity: 0.2;\n  transition: transform 0.2s ease-in-out;\n}\n.btn_style_one:hover:after {\n  transform: scale(1.2);\n}\n.btn_style_one > span {\n  position: relative;\n  z-index: 1;\n  transition: transform 0.3s ease-in-out;\n  display: inline-block;\n  color: #2f2e2e;\n}\n.btn_style_one:hover > span {\n  transform: scale(1.06);\n}\n\n.ittyb {\n  padding: 2rem 0;\n  background-attachment: fixed !important;\n}\n.ittyb_title > h2 {\n  font-size: 3.438rem;\n  line-height: 1;\n  margin-bottom: 2rem;\n  letter-spacing: 0.1rem;\n}\n\n.ittyb_item > h2 {\n  font-size: 1.3rem;\n  font-weight: 400;\n  margin-top: 2rem;\n  letter-spacing: 0.1rem;\n  margin-bottom: 1.5rem;\n}\n.ittyb_item,\n.ittyb_bt {\n  margin-bottom: 2rem;\n}\n.ittyb_item > p {\n  text-shadow: rgba(255, 255, 255, 0.6) 1px 1px 1px,\n    rgba(0, 0, 0, 0.6) -1px -1px 1px;\n  color: #b3f2ff;\n}\n.ittyb_bt > h3 {\n  font-size: 1.3rem;\n  font-weight: 400;\n  letter-spacing: 0.1rem;\n  margin-bottom: 1.5rem;\n}\n\n.video_banner {\n  height: 490px;\n  overflow: hidden;\n  background-color: #2f2e2e;\n}\n\n.features {\n  padding-bottom: 0.2rem;\n}\n.section_sales_heading{\n  font-size: 50px;\n    line-height: 1em;\n    text-align: center;\n    font-weight: bold;\n    color: #00305B;\n    letter-spacing: normal;\n}\n@media (min-width: 768px) {\n  .features_item {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .testimonials_section{\n    margin-bottom: 80px;\n  }\n}\n.features_item {\n  padding: 4.5rem 2.5rem;\n  color: #fff;\n  text-align: center;\n}\n.fi_card > img {\n  width: 4.875rem;\n  height: 4.875rem;\n  object-fit: contain;\n  object-position: center center;\n}\n.features_item ul {\n  text-align: left;\n}\n.fi_cta > a {\n  color: #fff;\n  text-decoration: none;\n}\n.fi_cta > a:hover {\n  text-decoration: underline;\n}\n.fi_card > h2 {\n  font-size: 1.4rem;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.25rem;\n  line-height: 1;\n}\n\n.gift_of_travel_new {\n  background-color: #fff;\n  padding: 3rem 0;\n}\n.gt_title {\n  margin-bottom: 4rem;\n}\n.gt_title > h2 {\n  font-size: 2.125rem;\n  letter-spacing: 0.15rem;\n  font-weight: 300;\n}\n.gt_title > p {\n  font-size: 1.2rem;\n}\n.gallery_item img {\n  width: 100%;\n  height: 280px;\n  object-fit: cover;\n  object-position: center;\n}\n.gellery_ovarley {\n  position: absolute;\n  background-color: rgba(47, 46, 46, 0.6);\n  inset: 0;\n  transition: opacity 0.3s ease;\n  opacity: 0;\n  pointer-events: none;\n}\n.gallery_item:hover .gellery_ovarley,\n.gallery_item:hover .react_btn,\n.gallery_item:hover .share_btn {\n  opacity: 1;\n}\n.react_btn,\n.share_btn {\n  position: absolute;\n  bottom: 2rem;\n  width: 3rem;\n  height: 3rem;\n  text-align: center;\n  line-height: 3rem;\n  color: #fff;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n.react_btn {\n  left: 2rem;\n}\n.share_btn {\n  right: 2rem;\n}\n\n.vacation_offers {\n  padding: 2rem 0;\n}\n.vo_title {\n  margin-bottom: 3rem;\n}\n.vo_title > h2 {\n  font-size: 3.625rem;\n  line-height: 1;\n  margin: 0;\n  font-family: \"Barlow\", sans-serif;\n}\n.swiperVo-prev,\n.swiperVo-next {\n  position: absolute;\n  /* top: 0; */\n  bottom: 0;\n  z-index: 10;\n  cursor: pointer;\n  color: #fff;\n}\n.swiperVo-prev:hover,\n.swiperVo-next:hover {\n  background-color: rgb(255 255 255 / 55%);\n  color: #282828;\n}\n.swiperVo-prev {\n  left: 0;\n}\n.swiperVo-next {\n  right: 0;\n}\n.swiperVo .swiper-slide {\n  position: relative;\n}\n.gi_react {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(110, 105, 104, 0.6);\n  transition: opacity 0.3s ease;\n  opacity: 0;\n}\n.swiperVo .swiper-slide:hover .gi_react {\n  opacity: 1;\n}\n.gi_react > span {\n  width: 3rem;\n  height: 3rem;\n  text-align: center;\n  line-height: 3rem;\n  cursor: pointer;\n}\n\n.wwo {\n  padding-bottom: 3rem;\n}\n.wwo_wrapper {\n  border: 2px solid #e9e9e9;\n  margin: 0 8rem;\n}\n.wwo_item {\n  padding: 2rem 3.5rem;\n  position: relative;\n}\n.wwo_item > img {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n  object-position: center;\n  margin-bottom: 1.2rem;\n}\n.wwo_item:nth-child(2):after,\n.wwo_item:nth-child(2):before {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  top: 3rem;\n  bottom: 3rem;\n  background-color: #fff;\n}\n.wwo_item:nth-child(2):before {\n  left: 0;\n}\n\n.wwo_item:nth-child(2):after {\n  right: 0;\n}\n\n.imagine {\n  background-color: rgb(209 202 201 / 50%);\n  padding: 2rem 0;\n}\n.imagine_title h2 {\n  font-size: 2.5rem;\n}\n.imagine_title p {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n.imagine_text p {\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.trial {\n  background-color: rgb(53 74 89 / 50%);\n  padding: 3rem 0;\n}\n.trial_title h2 {\n  font-size: 3.5rem;\n}\n\n.plan {\n  background-color: #fff;\n  padding: 2rem 0;\n}\n.plan_title h2 {\n  font-size: 3.5rem;\n  color: #354a59;\n  margin: 0;\n}\n.plan_title h5 {\n  font-size: 1.313rem;\n  color: #6e6968;\n}\n.plan_text_list {\n  padding: 2rem 10vw 0;\n}\n/* .pt_item {\n  height: 100%;\n  border: 2px solid #345166;\n  padding: 2rem;\n} */\n.pt_item {\n  height: 100%;\n  border-right: 2px solid #345166;\n  padding: 2rem;\n}\n\n.pt_item {\n  height: 100%;\n  border-right: 3px solid #345166;\n  padding: 2rem;\n}\n.pt_item h2 {\n  font-size: 2rem;\n  color: #354a59;\n  line-height: 1;\n}\n.plan_price {\n  /* font-size: 2rem; */\n  color: #354a59;\n  /* font-weight: 800; */\n  line-height: 1.2;\n  margin-bottom: 1rem;\n}\n.pt_item p {\n  color: #354a59;\n  font-size: 1.1rem;\n}\n.btn_style_two {\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n  padding: 0.8rem 2rem;\n  line-height: 1;\n  border: 0;\n  box-shadow: none;\n  transition: box-shadow 0.2s ease-in-out;\n}\n.btn_style_two:hover {\n  box-shadow: 1.41px 1.41px 4px rgba(0, 0, 0, 0.15);\n}\n.btn_style_two:after {\n  content: \"\";\n  background: #fffdf4 url(../../assets/images/btn_style_two.png);\n  inset: 0;\n  position: absolute;\n  opacity: 0.2;\n  transition: transform 0.2s ease-in-out;\n  background-size: 70%;\n}\n\n.plan_tires {\n  border: 2px solid #345166;\n  padding: 20px;\n}\n\n.btn_style_two:before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-color: #a0b3c1;\n  z-index: 1;\n}\n\n.btn_style_two:hover:before {\n  opacity: 0;\n}\n.btn_style_two > span {\n  color: #22282c;\n  position: relative;\n  z-index: 10;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-block;\n  transition: transform 0.2s ease-in-out;\n}\n.btn_style_two:hover > span {\n  transform: scale(1.08);\n}\n\n.get_it {\n  background-color: #fff;\n  padding: 3rem 0 2rem;\n}\n.getit_title h2 {\n  font-size: 3.5rem;\n  font-weight: 400;\n  color: #00305b;\n  letter-spacing: 0.19rem;\n}\n.vf_wrapper {\n  padding: 1rem 10vw 0;\n}\n.getit_form .form-control {\n  border-color: #3c3c3c;\n}\n\n.swiperTestimonials-prev,\n.swiperTestimonials-next {\n  position: absolute;\n  top: 50%;\n  z-index: 10;\n  cursor: pointer;\n  color: #fff;\n}\n.swiperTestimonials-prev {\n  left: 0;\n}\n.swiperTestimonials-next {\n  right: 0;\n}\n\n.landing {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 400;\n  color: #2f2e2e;\n}\n.landing h1, \n.landing h2, \n.landing h3, \n.landing h4, \n.landing h5, \n.landing h6 {\n  font-family: \"Barlow Condensed\", sans-serif;\n  font-weight: 500;\n}\n\n@media (min-width: 1300px) {\n  .landing .container, \n  .landing .container-lg, \n  .landing .container-md, \n  .landing .container-sm, \n  .landing .container-xl {\n      max-width: 1260px;\n  }\n  .testimonials_section{\n    margin-bottom: 250px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .features_item {\n    padding: 3rem 1rem;\n  }\n  .fi_card > h2 {\n    letter-spacing: 0;\n    font-size: 1.2rem;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .ittyb_item img {\n    width: 80px;\n    height: 80px;\n  }\n  .testimonials_section{\n    margin-bottom: 250px;\n  }\n}\n@media screen and (max-width: 991px) {\n  .getit_title h2,\n  .vo_title > h2,\n  .imagine_title h2,\n  .ittyb_title > h2 {\n    font-size: 2.5rem;\n  }\n  .pt_item {\n    padding: 1rem;\n  }\n  .plan_text_list {\n    padding: 2rem 0 0;\n  }\n  .wwo_wrapper {\n    margin: 0;\n  }\n  .testimonials_section{\n    margin-bottom: 100px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .banner_img {\n    text-align: center;\n  }\n  .banner_text h2 {\n    font-size: 2.4rem;\n  }\n  .video_banner {\n    height: 340px;\n  }\n  .sales_text > h2,\n  .sales_title > h2,\n  .getit_title h2,\n  .vo_title > h2,\n  .imagine_title h2,\n  .ittyb_title > h2,\n  .trial_title h2,\n  .plan_title h2 {\n    font-size: 2rem;\n  }\n  .sales_text p {\n    letter-spacing: 0;\n    font-size: 1rem;\n  }\n  .wwo_item:nth-child(2):after,\n  .wwo_item:nth-child(2):before {\n    display: none;\n  }\n  .plan_tires .row {\n    row-gap: 1rem;\n  }\n  .testimonials_section{\n    margin-bottom: 50px;\n  }\n}\n@media screen and (max-width: 475px) {\n  .btn_style_one {\n    padding: 0.5rem 2rem;\n  }\n  .testimonials_section{\n    margin-bottom: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
